import "./caso.css";
import { useState, useEffect } from "react";
import { useSelector } from 'react-redux';
import { formatContent } from "../../utils/formatText";
import casos from "../../componentes/Caso/casos";
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import Buttons from "../../componentes/Buttons/Buttons";
import Pills from "../../componentes/pills/Pills";
import { conProyectosImg } from "../../conexiones/varConexiones";
import textCasos from "./dictionary.js";
import { Metrics } from "../../componentes/metrics/Metrics.js";

const Caso = ({scroll, requestScroll}) => {
    const { id } = useParams();
    const caso = Object.values(casos).find(c => c.id === String(id));
    const lang = useSelector((state) => state.lang.lang);
    const [estadoModal,cambiaEstadoModal] = useState({type:null,on:false,id:null,scroll:true});

    function scrollingWindows (){
        if(estadoModal.scroll === true){
        return window.scrollY > 0 ? window.scroll({top: 0,behavior: "smooth"}):null;
        }
    }
    useEffect(()=>{
        scrollingWindows()
    }, [estadoModal.scroll])

    if (!caso) {
        return <div className="caso"><div className="caso-main"><div className="caso-header"><p className="caso-header-rotulo">Caso</p><h2 className="caso-header-title">Proyecto no encontrado</h2></div></div></div>;
    }

    const metricsList = Object.values(caso[lang].metricas || {});
    return (
        <div className="caso">
            <div className="caso-main">
                <div className="caso-header">
                    <p className="caso-header-rotulo">Caso</p>                
                    <h2 className="caso-header-title">{caso[lang].proyecto}</h2>
                    <h5 className="caso-header-bajada">{caso[lang].descripcion}</h5>
                    <div className="caso-header-skills">
                        {caso.skills.map(
                            (skill)=> <Pills key={skill} type={'outlined'} color={'white'} text={skill} icon={''}></Pills>
                        )}
                    </div>
                </div>
                <div className="devider h"></div>
                <div className="caso-cuerpo">
                    <div className="caso-cuerpo-section">
                      <h4>{textCasos.contexto[lang]}</h4>
                        {formatContent(caso[lang].contexto)}  
                    </div>
                    {caso.imgs.portada? <div style={{backgroundImage:`url(${conProyectosImg}/${id}/${caso.imgs.portada}.jpg)`}} className="caso-cuerpo-image"></div>:''}
                    <div className="caso-cuerpo-section">
                        <h4>{textCasos.investigacion[lang]}</h4>
                        {formatContent(caso[lang].Investigacion)}
                    </div>
                    <div className="caso-cuerpo-section">
                        <h4>{textCasos.solucion[lang]}</h4>
                        {formatContent(caso[lang].solucion)}
                        {metricsList?
                            <div className="content-metrics">
                                {
                                    metricsList.map((metrica, index) => 
                                        <Metrics key={index} metric={metrica.call} title={metrica.subtitle} description={metrica.description}></Metrics>
                                    )
                                }
                        </div>:''}
                    </div>
                    {caso.imgs.solucion?
                        <div className="caso-cuerpo-img-solucion">
                            {caso.imgs.solucion.map((img)=><div style={{backgroundImage:`url(${conProyectosImg}${id}/${img}.jpg)`}} className="caso-cuerpo-image"></div>)}
                        </div>:''
                    }
                    <div className="caso-cuerpo-section">
                        <h4>{textCasos.aprendizajes[lang]}</h4>
                        {formatContent(caso[lang].aprendizajes)}
                    </div>
                </div>
                <div className="caso-back">
                        <Link className='Link' to="/Home">
                            <Buttons
                                type={'primary'}
                                onClick={() => {
                                    if (typeof requestScroll === 'function') {
                                        requestScroll('main');
                                        return;
                                    }

                                    if (typeof scroll === 'function') {
                                        scroll('reset');
                                    }
                                }}
                                cta={'Volver'}
                            ></Buttons>
                        </Link>
                </div>
            </div>
        </div>
    )
}

export default Caso;